// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pointer-events[data-v-6b0835c2]{pointer-events:auto!important}", "",{"version":3,"sources":["webpack://./resources/js/Components/Customers/Contracts/SsoButtons.vue"],"names":[],"mappings":"AACA,iCACI,6BAAA","sourcesContent":["\n.pointer-events {\n    pointer-events: auto !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
